import { StorageConfigProvider } from './storage-config.provider';
import { MessageProvider } from './message.provider';
import { UsuarioProvider } from './usuario.provider';
import { MenuProvider } from './menu.provider';
import {ModalProvider} from './modal.provider';

export const PROVIDERS: Array<any> = [
    StorageConfigProvider,
    MessageProvider,
    UsuarioProvider,
    MenuProvider,
    ModalProvider
];
